import React, { Component } from "react"
import PropTypes from 'prop-types'
import MetaTags from 'react-meta-tags';
import { Link } from "react-router-dom"
import {
  Container,
  Row,
  Col,
  CardBody,
  Card,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
  CardHeader,
  Offcanvas,
  OffcanvasHeader,
  OffcanvasBody,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  FormGroup,
  Label,
  Input,
  Button,
  InputGroup,
  Collapse
} from "reactstrap"
import classnames from "classnames"
import Swal from "sweetalert2"
import { connect } from "react-redux"
import CurrencyFormat from 'react-currency-format';
import Breadcrumbs from "../../components/Common/Breadcrumb"
import PlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-places-autocomplete';
//i18n
import { withTranslation } from "react-i18next"
import { isEmpty, map, size } from "lodash";
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file
import { DateRangePicker } from 'react-date-range';
import Flatpickr from "react-flatpickr"
import "chartist/dist/scss/chartist.scss";
import "../../assets/scss/chartist.scss";
import TransactionColumnchart from "./chart/data/Transactioncolumnchart"
import TransactionSpineline from "./chart/data/TransactionSpinelinechart"
import TransactionPiechart from "./chart/data/TransactionPiechart";
import Moment from 'react-moment';
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { getAgentTransaction, getAgentAllTransaction} from "../../store/actions";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import RsLink from "components/buttons/rsLink";
import axios from "axios"
import { API_URL } from "helpers/app_url";
import { BlobServiceClient } from '@azure/storage-blob';
import {azureConfig} from "helpers/azureConfig";
import RsAdNew from "components/buttons/Adnew";
import SaveButton from "components/buttons/save";
import ActionDelete from "components/buttons/actionDelete";
import leadImg from "../../assets/img/conversion-icon.png"
import SafeField from "helpers/SafeField";
class TransactionDashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      //alltransactions: [],     
      filteredTransactions: [], 
      selectedStatus: "",
       activeTab3: "7",
       transaction: {},     
          activeCategories: {},  
    };
      this.toggleManage = this.toggleManage.bind(this);
        this.toggle3 = this.toggle3.bind(this);
      
        this.handleDocumentSubmit = this.handleDocumentSubmit.bind(this)
  }
  componentDidMount() {
    const { onGetAgentTransaction, onGetAgentAllTransaction } = this.props;
    onGetAgentTransaction(localStorage.getItem('userId'));
    onGetAgentAllTransaction(localStorage.getItem('userId'));
  }
  componentDidUpdate(prevProps, prevState) {
  
  if (prevProps.transactions !== this.props.transactions) {
    this.applyFilter();
  }

  
  if (prevState.selectedStatus !== this.state.selectedStatus) {
    this.applyFilter();
  }
}
handleStatusChange = (event) => {
    const value = event.target.value;
    this.setState({ selectedStatus: value }, () => {
      this.applyFilter();
    });
  };
   applyFilter = () => {
  const { transactions } = this.props; 
  const { selectedStatus } = this.state;

  if (selectedStatus === "") {
    this.setState({ filteredTransactions: transactions?.clientTransactions || [] });
  } else {
    const filtered = transactions?.clientTransactions.filter(
      (item) => String(item.clientEngagementStatus) === selectedStatus
    );
    this.setState({ filteredTransactions: filtered });
  }
};
// For Deal Manage

  fetchBuyerListing(listingId) {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;
    const headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };
    axios
      .get(`${API_URL}AgentClientPotentialListing/${listingId}`, { headers })
      .then((response) => {
        this.setState({ buyerListing: response.data, loading: false });
      })
      .catch((error) => {
        this.setState({ error: error.message, loading: false });
      });
  }

  fetchSellerListing(listingId) {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;
    const headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };
    axios
      .get(`${API_URL}ClientSellerShowing/byid?sellerShowingId=${listingId}`, { headers })
      .then((response) => {
        this.setState({ sellerListing: response.data, loading: false });
      })
      .catch((error) => {
        this.setState({ error: error.message, loading: false });
      });
  }

  fetchInvestorListing(clientId, listingId) {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;
    const headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };
    const params = {
      agentId: localStorage.getItem("userId"),
      clientId: clientId,
      selectedOptionId: listingId
    };
    axios
      .get(`${API_URL}ProjectCampaignClient/projectselectedoption`, { headers, params })
      .then((response) => {
        this.setState({ investorListing: response.data, loading: false });
      })
      .catch((error) => {
        this.setState({ error: error.message, loading: false });
      });
  }
 toggleManage() {
    this.setState({ transaction: "", isEdit: false, isManage: !this.state.isManage, activeTab3: "7" });
    this.toggle();
  }
  toggleManage = arg => {
    const transaction = arg;
    
    this.setState({
      transaction: {
        id: transaction?.id,
        clientEngagementId: transaction?.clientEngagementId,
        contactName: transaction?.contactName,
        contactAddress: transaction?.contactAddress,
        clientEngagementStatus: transaction?.clientEngagementStatus,
        commissionTypeId: transaction?.commissionTypeId,
        commissionValue: transaction?.commissionValue,
        closingDate: transaction?.closingDate,
        startDate: transaction?.startDate,
        endDate: transaction?.endDate,
        propertyAddress: transaction?.propertyAddress,
        transactionAmount: transaction?.transactionAmount,
        commissionValue: transaction?.commissionValue,
        isBuyer: transaction?.isBuyer,
        isSeller: transaction?.isSeller,
        isInvestor: transaction?.isInvestor,
        buyerType: transaction?.buyerType,
        sellerType: transaction?.sellerType,

        agentName: transaction?.agentName,
        agentOfficeName: transaction?.agentOfficeName,
        agentMobile: transaction?.agentMobile,
        agentEmail: transaction?.agentEmail,
        clientName:transaction?.clientName,
        clientMobile: transaction?.clientMobile,
        clientEmail: transaction?.clientEmail,
        clinetPhone: transaction?.clientPhone,
        secondaryClientName: transaction?.secondaryClientName,
        secondaryClientEmail: transaction?.secondaryClientEmail,
        secondaryClientMobile: transaction?.secondaryClientMobile,
        secondaryClientPhone: transaction?.secondaryClientPhone,
        dealRefId:transaction?.dealRefId,
        clientId: transaction?.clientId
      },  
      isEdit: true,
    });
    this.fetchMortgageContact(transaction?.clientId, transaction?.id);
    this.fetchLegalContact(transaction?.clientId, transaction?.id);
    this.fetchDealdocument(transaction?.clientId, transaction?.id);
    if (transaction?.isBuyer) {
      this.fetchBuyerClosingChecklist()
      this.fetchBuyerDealChecklist(transaction?.clientId, transaction?.id);
      this.fetchBuyerListing(transaction?.dealRefId);
      this.fecthBuyerDealChecklist();
      this.fecthBuyerDealSelectedChecklist(transaction?.id, transaction?.clientId);
       this.GetBuyerClientOffersByDealId(transaction?.id);
    } else if (transaction?.isSeller) {
      this.fetchSellerClosingChecklist();
      this.fetchSellerChecklist(transaction?.clientId,transaction?.id);
      this.fetchSellerListing(transaction?.dealRefId);
      this.fecthSellerDealChecklist();
      this.fecthSellerDealSelectedChecklist(transaction?.id, transaction?.clientId);
      this.GetSellerClientOffersByDealId(transaction?.id);
    }else if(transaction?.isInvestor) {
      this.fetchInvestorListing(transaction?.clientId, transaction?.dealRefId);
    }
    this.toggle();

  };

fecthBuyerDealChecklist = () => {
      const authUser = localStorage.getItem("authUser");
      if (!authUser) return;
      const obj = JSON.parse(authUser);
      const token = obj?.resultData?.bearerToken;
      if (!token) return;
      const str = 'Bearer ' + token;
      axios.get(`${API_URL}ClientDealCheckList/allforagenttype`, {
          params: { agentId: parseInt(localStorage.getItem("userId")),
              forType : 1
           },
          headers: { Authorization: str }
      })
      .then(res => this.setState({ alldealChecklists: res.data }))
      .catch(err => console.error("Error fetching templates:", err));
  }
  fecthSellerDealChecklist = () => {
      const authUser = localStorage.getItem("authUser");
      if (!authUser) return;
      const obj = JSON.parse(authUser);
      const token = obj?.resultData?.bearerToken;
      if (!token) return;
      const str = 'Bearer ' + token;
      axios.get(`${API_URL}ClientDealCheckList/allforagenttype`, {
          params: { agentId: parseInt(localStorage.getItem("userId")),
              forType : 2
           },
          headers: { Authorization: str }
      })
      .then(res => this.setState({ alldealChecklists: res.data }))
      .catch(err => console.error("Error fetching templates:", err));
  }
  fecthBuyerDealSelectedChecklist(dealId, clientId) {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;
    const headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };

    const params = {
      DealId: dealId,
      ClientTypeId: 1,
      ClientId: clientId,
      AgentId: localStorage.getItem('userId')
    };
    axios
      .get(`${API_URL}ClientBuyerDealCheckList/allfordeal`, { headers, params })
      .then((response) => {
       
        this.setState({
          newdealChecklists: response.data,
          loading: false
        });
      })
      .catch((error) => {
        this.setState({ error: error.message, loading: false });
      });
  }


    fecthSellerDealSelectedChecklist(dealId, clientId) {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;
    const headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };

    const params = {
      DealId: dealId,
      ClientTypeId: 2,
      ClientId: clientId,
      AgentId: localStorage.getItem('userId')
    };
    axios
      .get(`${API_URL}ClientSellerDealCheckList/allfordeal`, { headers, params })
      .then((response) => {
       
        this.setState({
          newdealChecklists: response.data,
          loading: false
        });
      })
      .catch((error) => {
        this.setState({ error: error.message, loading: false });
      });
  }

     GetSellerClientOffersByDealId(dealId) {
      const obj = JSON.parse(localStorage.getItem("authUser"));
      const token = obj?.resultData?.bearerToken;
      const headers = {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      };
  
      const params = {
        dealId: dealId,
      };
      axios
        .get(`${API_URL}ClientOffer/GetSellerClientOffersByDealId`, { headers, params })
        .then((response) => {
          const offers = response.data;
          this.setState({
            clientSellerOffer: Array.isArray(offers) && offers.length > 0 ? offers[0] : {},
            loading: false
          });
        })
        .catch((error) => {
          this.setState({ error: error.message, loading: false });
        });
    }
  
    GetBuyerClientOffersByDealId(dealId) {
      const obj = JSON.parse(localStorage.getItem("authUser"));
      const token = obj?.resultData?.bearerToken;
      const headers = {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      };
  
      const params = {
        dealId: dealId,
      };
      axios
        .get(`${API_URL}ClientOffer/GetBuyerClientOffersByDealId`, { headers, params })
        .then((response) => {
          const offers = response.data;
          this.setState({
            clientBuyerOffer:  Array.isArray(offers) && offers.length > 0 ? offers[0] : {},
            loading: false
          });
        })
        .catch((error) => {
          this.setState({ error: error.message, loading: false });
        });
    }
  toggle() {
    this.setState(prevState => ({
      isManage: !prevState.isManage,
       activeTab3: !prevState.isRight ? "7" : prevState.activeTab3,
    }));
  }
    toggleCategory = (category) => {
    this.setState((prevState) => ({
      activeCategories: {
        ...prevState.activeCategories,
        [category]: !prevState.activeCategories[category],
      },
    }));
  };
  handleDocumentSubmit(value) {
    const payload = {
      clientEngagementId: parseInt(value.clientEngagementId),
      agreementDocumentFromId: parseInt(value.agreementDocumentFromId),
      agreementDocumentToId: parseInt(value.agreementDocumentToId),
      agreementDocumentTitle: value.agreementDocumentTitle,
      agreementDocumentFrom: value.agreementDocumentFrom,
      agreementDocumentTo: value.agreementDocumentTo,
      agreementDocumentLink: value.agreementDocumentLink,
      agreementDocumentStorageType: parseInt(value.agreementDocumentStorageType),
      agentId: parseInt(value.agentId),
      isActive: true,
      isUrgent: false,
      sendNotification: false
    }
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;
    const url = `${API_URL}ClientAgreementDocument`;
    toast.loading("Please wait...");
    axios
      .post(url, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        if (response.data.success) {
          toast.dismiss();
          toast.success("Document submitted successfully!");
          this.setState({ fileUploaded: false });
          this.fetchDealdocument(value.agreementDocumentToId, value.clientEngagementId);

        } else {
          toast.dismiss();
          toast.error('some issue while uploading document');
          console.warn("Submission failed:", response.data);
        }
      })
      .catch((error) => {
        console.error("Error submitting document:", error);

      });
  }

  fetchBuyerDealChecklist(ClientId, dealId) {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;
    const headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };

    const params = {
      DealId: dealId,
      ClientTypeId: 1,
      ClientId: ClientId,
      AgentId: localStorage.getItem('userId')
    };
    axios
      .get(`${API_URL}ClientBuyerClosingCheckList/allfordeal`, { headers, params })
      .then((response) => {
        const fetchedSelectedTasks = response.data.map(
          (task) => task.clientClosingCheckListId
        );
        this.setState({
          dealChecklists: response.data,
          selectedChecklistIds: fetchedSelectedTasks,
          loading: false
        });
      })
      .catch((error) => {
        this.setState({ error: error.message, loading: false });
      });
  }


  fetchDealdocument(ClientId, dealId) {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;
    const headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };

    const params = {
      EngagementId: dealId,
      ClientId: ClientId,
      AgentId: localStorage.getItem('userId')
    };
    axios
      .get(`${API_URL}ClientAgreementDocument/allbyDeal`, { headers, params })
      .then((response) => {
        this.setState({ dealDocuments: response.data, loading: false });
      })
      .catch((error) => {
        this.setState({ error: error.message, loading: false });
      });
  }



  async handleFileChange(event, setFieldValue) {
    const file = event.currentTarget.files[0];
    if (file) {
      const maxSize = 5 * 1024 * 1024;
      const allowedTypes = ['application/pdf', 'application/msword', 'image/jpeg', 'image/png'];
      const allowedExtensions = ['.pdf', '.doc', '.jpg', '.jpeg', '.png'];
      const fileExtension = file.name.slice(file.name.lastIndexOf('.')).toLowerCase();
      if (!allowedTypes.includes(file.type) || !allowedExtensions.includes(fileExtension)) {
        Swal.fire({
          title: 'File type or extension not allowed',
          text: 'Please upload a PDF, DOC, JPG, or PNG file.',
          icon: 'warning',
          confirmButtonText: 'OK',
        });
        //alert('Invalid file type. Please upload a PDF, DOC, JPG, or PNG file.');
        return;
      }
      if (file.size > maxSize) {
        Swal.fire({
          title: 'Size not allowed',
          text: 'Please Upload Maximum 5MB File',
          icon: 'warning',
          confirmButtonText: 'OK',
        });

      }
      this.setState({ btnloading: true });
      const sasToken = azureConfig.sasToken;
      const containerName = azureConfig.containerName;
      const storageAccountName = azureConfig.storageAccountName;
      const fileName = `${Date.now()}_${file.name}`;
      const blobServiceClient = new BlobServiceClient(
        `https://${storageAccountName}.blob.core.windows.net?${sasToken}`
      );
      const containerClient = blobServiceClient.getContainerClient(containerName);
      const blobClient = containerClient.getBlockBlobClient(fileName);

      try {
        await blobClient.uploadBrowserData(file, {
          blobHTTPHeaders: { blobContentType: file.type }
        });


        if (setFieldValue) {
          const fileUrl = `https://${storageAccountName}.blob.core.windows.net/${containerName}/${fileName}`;
          setFieldValue(`agreementDocumentLink`, fileUrl);
          //setFieldValue(`agreementDocumentTitle`, fileUrl);
          this.setState({ fileUploaded: true });
        }
      } catch (error) {
        console.error('Error uploading file:', error);

      }
    }
  }

  getBuyerType = (type) => {
    if (type == 1)
      return 'Rent';
    else if (type == 2)
      return 'Purchase';

  }

  getSellerType = (type) => {
    if (type == 1)
      return 'Sell';
    else if (type == 2)
      return 'Lease';

  }
  getCommType = (type) => {
    if (type == 3)
      return 'Fixed';
    else if (type == 4)
      return 'Percentage';

  }
  toggle3(tab) {
    if (this.state.activeTab3 !== tab) {
      this.setState({
        activeTab3: tab,
      });
    }
  }
  fetchMortgageContact(clientId, dealId) {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;
    const headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };

    const params = {
      dealId: dealId,
      agentId: localStorage.getItem("userId"),
      clientId: clientId
    };
    axios
      .get(`${API_URL}ClientProfessionalContactExt/get_client_mortgage_contactdeal`, { headers, params })
      .then((response) => {
        this.setState({ mortgageContact: response.data, loading: false });
      })
      .catch((error) => {
        this.setState({ error: error.message, loading: false });
      });
  }
  fetchLegalContact(clientId, dealId) {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;
    const headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };

    const params = {
      dealId: dealId,
      agentId: localStorage.getItem("userId"),
      clientId: clientId
    };
    axios
      .get(`${API_URL}ClientProfessionalContactExt/get_client_legal_contactdeal`, { headers, params })
      .then((response) => {
        this.setState({ legalContact: response.data, loading: false });
      })
      .catch((error) => {
        this.setState({ error: error.message, loading: false });
      });
  }

  fetchSellerChecklist(ClientId, dealId) {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;
    const headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };

    const params = {
      DealId: dealId,
      ClientTypeId: 2,
      ClientId: ClientId,
      AgentId: localStorage.getItem('userId')
    };
    axios
      .get(`${API_URL}ClientSellerClosingCheckList/allfordeal`, { headers, params })
      .then((response) => {
        const fetchedSelectedTasks = response.data.map(
          (task) => task.clientClosingCheckListId
        );
        this.setState({
          dealChecklists: response.data,
          selectedChecklistIds: fetchedSelectedTasks,
          loading: false
        });
      })
      .catch((error) => {
        this.setState({ error: error.message, loading: false });
      });
  }


  fetchBuyerClosingChecklist() {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;
    const headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };

    const params = {
      forType: 1,
      agentId: localStorage.getItem("userId"),
      propertyType: 0
    };
    axios
      .get(`${API_URL}ClientClosingCheckList/allforagenttype`, { headers, params })
      .then((response) => {
        this.setState({ closingChecklist: response.data, loading: false });
      })
      .catch((error) => {
        this.setState({ error: error.message, loading: false });
      });
  }

  fetchSellerClosingChecklist() {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;
    const headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };

    const params = {
      forType: 2,
      agentId: localStorage.getItem("userId"),
      propertyType: 0
    };
    axios
      .get(`${API_URL}ClientClosingCheckList/allforagenttype`, { headers, params })
      .then((response) => {
        this.setState({ closingChecklist: response.data, loading: false });
      })
      .catch((error) => {
        this.setState({ error: error.message, loading: false });
      });
  }


getValue = (title) => {
    const { transactions } = this.props;
    const data = transactions?.saleTrackerGraphData || [];
    const item = data.find((d) => d.itemTitle === title);
    return item ? item.value1 : 0;
  };


  getSalesValue = (title) => {
    const { transactions } = this.props;
    const data = transactions?.saleTrackerGraphData || [];
    const item = data.find((d) => d.itemTitle === title);
    return item ? item.value2 : 0;
  };

  render() {
    const { transactions, alltransactions } = this.props;
    const { filteredTransactions, transaction, closingChecklist, fileUploaded, mortgageContact, legalContact, dealDocuments, 
      dealChecklists, buyerListing, sellerListing, investorListing, newdealChecklists, clientSellerOffer, clientBuyerOffer } = this.state;
    const allLocal = localStorage.getItem('localData')
    const localization = JSON.parse(allLocal);
  const groupedChecklist = closingChecklist?.reduce((acc, item) => {
      acc[item.checkListCategory] = acc[item.checkListCategory] || [];
      acc[item.checkListCategory].push(item);
      return acc;
    }, {});
      const startDate = transaction?.startDate ? new Date(transaction?.startDate) : null;
    const formattedDate = startDate
      ? `${startDate.getFullYear().toString().slice(-2)}${(startDate.getMonth() + 1).toString().padStart(2, '0')}`
      : "";
    const generatedDealId = transaction?.id ? `${transaction?.id}-${formattedDate}` : "";

    const data = {
    year: 2025,
    deals: {
      inProgress: 15,
      completed: 3,
      cancelled: 2,
      fellThrough: 0,
    },
    sales: {
      goal: 1500000,
      tillDate: 1300000,
      commission: 32500,
    },
  };
   const formatCurrency = (amount) =>
    `$${amount.toLocaleString("en-US", { minimumFractionDigits: 0 })}`;
    //

    //console.log(investorListing);
    return (
      <React.Fragment>
        {this.props.loading && this.props.loading ? (
                    <div className="loading">Loading&#8230;</div>
                ) : null}
        <div className="page-content project-page-content">
          <MetaTags>
            <title>Create Template | Realty Space</title>
          </MetaTags>
          <Container fluid className=" ">
            {/* Render Breadcrumb */}

            <Row className="project-header">
              <Col sm="12">
                <Breadcrumbs
                  title={this.props.t("Reports")}
                  breadcrumbItem={this.props.t("Deals")}
                />
              </Col>
              {/* <Col sm="6">
              
              </Col> */}
            </Row>
            <Row className="text-center mb-4 mt-4">
        <Col md="6">
    
          <Card className="p-3 shadow-sm border-0">
            <Row className="text-center">
              <Col xs="12" sm="6" md="2">
                <h4 className="font-size-18 mb-1 text-dark mt-2">{data.year}</h4>
                
              </Col>
              <Col xs="12" sm="6" md="2">
               
                <h4 className="font-size-18 mb-1 text-dark  mt-2">Deals</h4>
              </Col>
              <Col xs="12" sm="6" md="8">
                <Row className="text-center">
                    <Col xs="12" sm="6" md="3">
               <h4 className="fw-bold text-dark ">{this.getValue("#In Progress")}</h4>
                <p className="text-dark fw-bold  mb-0">In Progress</p>
              </Col>
                 <Col xs="12" sm="6" md="3">
                <h4 className="fw-bold text-dark "> {this.getValue("#Completed")}</h4>
                <p className="text-dark fw-bold mb-0">Completed</p>
              </Col>
               <Col xs="12" sm="6" md="3">
                    <h4 className="fw-bold text-dark "> {this.getValue("#Cancelled")}</h4>
                  <p className="text-dark fw-bold  mb-0">Cancelled</p>
              </Col>
               <Col xs="12" sm="6" md="3">
                    <h4 className="fw-bold text-dark "> {this.getValue("#Fell Through")}</h4>
                <p className="text-dark fw-bold  mb-0">Fell Through</p>
              </Col>
                </Row>
               
              </Col>
             
            </Row>

      
          </Card>
        </Col>

        <Col md="6">
            <Card className="p-3 shadow-sm border-0">
            <Row className="text-center">
             
              <Col xs="12" sm="6" md="2">
               
                <h4 className="font-size-18 mb-1 mt-2 text-dark">Sales</h4>
              </Col>
              <Col xs="12" sm="6" md="8">
                <Row className="text-center">
                    <Col xs="12" sm="6" md="4">
               <h4 className="fw-bold text-dark"> {formatCurrency(this.getValue("Sales Volumn"))}</h4>
                <p className="text-dark fw-bold mb-0">Goal</p>
              </Col>
                 <Col xs="12" sm="6" md="4">
                <h4 className="fw-bold text-dark"> {formatCurrency(this.getSalesValue("Sales Volumn"))}</h4>
                <p className="text-dark fw-bold mb-0">Till date</p>
              </Col>
               <Col xs="12" sm="6" md="4">
                    <h4 className="fw-bold text-dark">{formatCurrency(this.getSalesValue("Gross Comission"))}</h4>
                  <p className="text-dark fw-bold mb-0">Commission</p>
              </Col>
              
                </Row>
               
              </Col>
             
            </Row>

      
          </Card>
        </Col>
      </Row>
            {/* <Row className="bg-yellow">
              <Col sm="2">
                <div className={`bg-v2 p-2 m-1`}>
        <div className="rs-card-compact ">
          <Row>
             <Col xs="4" className="text-center">
            
              <h6 className="font-size-18 mb-1">2025</h6>
            </Col>
            <Col xs="6">
             
            </Col>
           
          </Row>
        </div>
      </div>
              </Col>
  {map(transactions.saleTrackerGraphData, (saleTracker, saleTrackerkey) => (
    <Col md={saleTrackerkey == 1 ? '4' : '3' } key={"_list_" + saleTrackerkey}>
      <div className={`bg-v2 p-2 m-1`}>
        <div className="rs-card-compact ">
          <Row>
             <Col md={saleTrackerkey == 1 ? '4' : '6' } className="text-center">
             
              <h6 className="font-size-18 mb-1">{saleTracker.itemTitle}</h6>
            </Col>
            <Col xs="6">
              <Row className="price-data mb-20">
                 { saleTrackerkey != 2 ? <Col sm="6"><h3 className={`${(saleTrackerkey  == 2 ? 'd-none' : '')}`}>{ saleTracker.itemTitle!='#Transactions'  ? <CurrencyFormat value={saleTracker.value1} displayType={'text'} thousandSeparator={true} prefix={'$'} /> : saleTracker.value1 }</h3></Col> : '' }
                <Col sm="6"><h3>{ saleTracker.itemTitle!='#Transactions'  ? <CurrencyFormat value={saleTracker.value2} displayType={'text'} thousandSeparator={true} prefix={'$'} /> : saleTracker.value2 }</h3></Col>
              </Row>
              <Row>
                { saleTrackerkey != 2 ? <Col sm="6"><h5 className={`${(saleTrackerkey  == 2 ? 'd-none' : '')}`}>Goal</h5></Col> : '' }
                <Col sm="6"><h5>Actual</h5></Col>
              </Row>
            </Col>
           
          </Row>
        </div>
      </div>
    </Col>
  ))}
</Row>
              */}
           
                      
                <Row>
               {/* <Col sm="4" className="d-flex">
              <Card className="border-full w-100 mt-4"> 
               
            <CardBody className="d-flex flex-column"> 
                <div className="card-title mb-4">Sales Tracker</div>
                
          <div className="clearfix"></div>
                    <div className="table-responsive">
                      <table className="table align-middle table-nowrap mb-0">
                        <thead className="table-light">
                          <tr>

                           

                            <th className="align-middle">Matric</th>
                            <th className="align-middle">Goal</th>
                            <th className="align-middle">Actual</th>
                           

                          </tr>
                        </thead>
                        <tbody>
                        {map(transactions.saleTrackerGraphData, (saleTracker, saleTrackerkey) => (
                            <tr key={"_list_" + saleTrackerkey}>
                                <td>{saleTracker.itemTitle}</td>
                                <td>{ saleTracker.itemTitle!='#Transactions'  ? <CurrencyFormat value={saleTracker.value1} displayType={'text'} thousandSeparator={true} prefix={'$'} /> : saleTracker.value1 }</td>
                                <td>{ saleTracker.itemTitle!='#Transactions'  ? <CurrencyFormat value={saleTracker.value2} displayType={'text'} thousandSeparator={true} prefix={'$'} /> : saleTracker.value2 }</td>
                            </tr>
                        ))}
                            
                        </tbody>
                      </table>
                    </div>
                     </CardBody>
                </Card>
              </Col> */}
                     <Col sm="6" className="d-flex">
              <Card className="border-full w-100 mt-4"> 
            <CardBody className="d-flex flex-column"> 
                
                    <div className="card-title mb-4">Sales Pipeline</div>
                            <TransactionColumnchart />
                    </CardBody> 
                </Card>
                    </Col>
                    <Col sm="6">
                     <Card className="border-full mt-4">
                  <CardBody>
                <div className="card-title mb-4">
                    Goal Tracker</div>      
                   <TransactionSpineline />
                   </CardBody>
                </Card>
                    </Col>
                  
                </Row>
               
         
             <Card className="border-full mt-4">
                <CardHeader>
                  <div className="row">
                    <div className="col-sm-2">
                      <div className="btn-group rl-group-btn w-100" role="group">
                        <Link to="/transaction/deal">
                          <button
                            type="button"
                            className="btn btn-outline-secondary w-100 bt-filter-v2 active"
                          >
                            <span className="d-flex align-items-center gap-2">
                              <span>View deals</span>
                            </span>
                          </button>
                        </Link>

                        <Link to="/goal">
                          <button
                            type="button"
                            className="btn btn-outline-secondary w-100 bt-filter-v2"
                          >
                            <span className="d-flex align-items-center gap-2">
                              <span>Goals</span>
                            </span>
                          </button>
                        </Link>
                      </div>
                    </div>
                     <Col className="p-0" sm="2" style={{ width: 37 }}>
                            <label className="fom-label font-size-14" style={{ marginTop: 8, color: '#000' }}>Filter</label>
                                                    </Col>
                    <div className="col-sm-2">
                      <select
                        className="form-select select-filter w-100"
                        onChange={this.handleStatusChange}
                      >
                        <option value="">All Deals</option>
                        <option value="0">New</option>
                        <option value="1">In-Progress</option>
                        <option value="2">Completed</option>
                        <option value="3">Cancelled</option>
                        <option value="4">Fell Through</option>
                      </select>
                    </div>
                 
                  </div>
                  
                 </CardHeader>
                    <CardBody>
           <Row>
            <Col sm="12">
             
            
          
            <DataTable className="" stripedRows value={filteredTransactions} paginator rows={10} rowsPerPageOptions={[10, 20, 30, 50, 100, 150, 200, 500 ]} currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries " paginatorTemplate=" FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown   " tableStyle={{ minWidth: '50rem' }}   >
                {/* <Column  field="eventTitle" header="" body={(rowData) => (
                  <div className="form-check font-size-16 align-middle">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    id="customCheck1"
                  />
                  <label
                    className="form-check-label"
                    htmlFor="customCheck1"
                  >
                    &nbsp;
                  </label>
                </div>
                )}>  </Column> */}
                 <Column
    header="#"
    body={(rowData, options) => options.rowIndex + 1}
    style={{ width: '60px' }}
  />

                <Column
                  field="contactName"
                  header="Client Name"
                  body={(rowData) => (
                    rowData.clientEngagementStatus === 2 ? (
                      <Link
                        to="#"
                        onClick={() => this.toggleManage(rowData)}
                        className=""
                      >
                       {rowData.contactName}
                      </Link>
                    ) : (
                      <>
                      {rowData.contactName}
                      </>
                    )
                  )}
                />
               {/* <Column
                  field="contactName"
                  header="Client Name"
                  body={(rowData) => (
                    <Link
                      to="#"
                      onClick={() => this.toggleManage(rowData)}
                      className=""
                    >
                      {rowData.contactName}
                    </Link>
                  )}
                /> */}
                {/* <Column  field="contactName" header="Client Name"></Column> */}
                {/* <Column  field="contactAddress" header="Address"></Column> */}
                 <Column  field="lastAgreementDate" header="Agreement" body={(rowData) => (
                    rowData.lastAgreementDate ? <Moment format="D MMM YY">{rowData.lastAgreementDate}</Moment> : ''
                )}></Column>
                <Column field="type" header="Type" body={(rowData) => {
                                if (rowData.isBuyer) return `Buyer ${rowData.buyerType ? `- ${this.getBuyerType(rowData.buyerType)}` : ""}`;
                                if (rowData.isSeller) return `Seller ${rowData.sellerType ? `- ${this.getSellerType(rowData.sellerType)}` : ""}`;
                                if (rowData.isInvestor) return "Investor";
                                return "N/A";
                              }} />
                 <Column  field="closingDate" header="Start Date" body={(rowData) => (
                    rowData.startDate ? <Moment format="D MMM YY">{rowData.startDate}</Moment> : ''
                )}></Column>
                <Column  field="closingDate" header="Closing Date" body={(rowData) => (
                    rowData.closingDate ? <Moment format="D MMM YY">{rowData.closingDate}</Moment> : ''
                )}></Column>
                <Column  field="salePrice" header="Sale Price" body={(rowData) =>(
                  <CurrencyFormat value={rowData.transactionAmount} displayType={'text'} thousandSeparator={true} prefix={'$'} />
                )}></Column>
                 <Column field="commissionValue" header="Commission" body={(rowData) => {
                    if (rowData.commissionTypeId === 3) {
                      return `$${rowData.commissionValue?.toFixed(2) || "0.00"}`;
                    }
                    if (rowData.commissionTypeId === 4) {
                      return `${rowData.commissionValue?.toFixed(2) || "0.00"} %`;
                    }
                  }}
                
                  />
                  <Column
                      field="commissionValue"
                      header="Commission Value"
                      body={(rowData) => {
                        const { commissionTypeId, commissionValue, transactionAmount, clientEngagementStatus } = rowData;

                        if (clientEngagementStatus !== 2) {
                              return "N/A";
                         }
                        // Type 3 = Fixed commission
                        if (commissionTypeId === 3) {
                          return (
                            <CurrencyFormat
                              value={commissionValue || 0}
                              displayType={"text"}
                              thousandSeparator={true}
                              prefix={"$"}
                              decimalScale={2}
                              fixedDecimalScale
                            />
                          );
                        }

                        // Type 4 = Percentage-based commission
                        if (commissionTypeId === 4) {
                          const percentage = commissionValue || 0;
                          const calculatedCommission = (transactionAmount * percentage) / 100;
                          return (
                            <>
                              <CurrencyFormat
                                value={calculatedCommission}
                                displayType={"text"}
                                thousandSeparator={true}
                                prefix={"$"}
                                decimalScale={2}
                                fixedDecimalScale
                              />
                            
                            </>
                          );
                        }

                        // Default case (no commission)
                        return "$0.00";
                      }}
                    />
             
                 <Column field="clientEngagementStatus" header="Status "body={(rowData) => {
                   if (rowData.clientEngagementStatus==0) return `New`;
                  if (rowData.clientEngagementStatus==1) return `In-Progress`;
                  if (rowData.clientEngagementStatus==2) return `Completed`;
                  if (rowData.clientEngagementStatus==3) return "Cancelled ";
                  if (rowData.clientEngagementStatus==4) return "Fell Through ";
                  return "N/A";
                }}  />
              
                <Column  field="clientSourceId" header="Source" body={(rowData) => (
                        rowData.clientSourceId ? localization["LeadSource_" + rowData.clientSourceId] : 'N/A'
                )}></Column>
                 
            </DataTable>
           
                      
                  
            </Col>
           </Row>
             </CardBody>
              </Card>
          
          </Container>

  <Offcanvas
              isOpen={this.state.isManage}
              direction="end"
              toggle={this.toggleManage}
              style={{ width: "900px" }}
            >
              <OffcanvasHeader toggle={this.toggleManage}>
                Manage Deal
              </OffcanvasHeader>
              <OffcanvasBody>
                <Nav pills className="navtab-bg nav-justified">
                   {/*<NavItem>
                    <NavLink
                      style={{ cursor: "pointer" }}
                      className={classnames({
                        active: this.state.activeTab3 === "1",
                      })}
                      onClick={() => {
                        this.toggle3("1");
                      }}
                    >
                      Deal info
                    </NavLink> 
                  </NavItem>*/}
                  {/* <NavItem>
                    <NavLink
                      style={{ cursor: "pointer" }}
                      className={classnames({
                        active: this.state.activeTab3 === "5",
                      })}
                      onClick={() => {
                        this.toggle3("5");
                      }}
                    >
                      Overview
                    </NavLink>
                  </NavItem> */}
                  <NavItem>
                    <NavLink
                      style={{ cursor: "pointer" }}
                      className={classnames({
                        active: this.state.activeTab3 === "7",
                      })}
                      onClick={() => {
                        this.toggle3("7");
                      }}
                    >
                      Deal
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      style={{ cursor: "pointer" }}
                      className={classnames({
                        active: this.state.activeTab3 === "2",
                      })}
                      onClick={() => {
                        this.toggle3("2");
                      }}
                    >
                      Documents
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      style={{ cursor: "pointer" }}
                      className={classnames({
                        active: this.state.activeTab3 === "3",
                      })}
                      onClick={() => {
                        this.toggle3("3");
                      }}
                    >
                      { transaction?.isBuyer ?  
                        <>Mortgage / Legal</>
                      : transaction?.isSeller ?
                        <>  Lawyer</>
                      :
                      <>Lawyer / Mortgage</>
                      }
                    </NavLink>
                  </NavItem>
                  {/* <NavItem>
                  <NavLink
                    style={{ 
                      cursor: transaction?.isInvestor ? "not-allowed" : "pointer", 
                      pointerEvents: transaction?.isInvestor ? "none" : "auto", 
                      opacity: transaction?.isInvestor ? 0.1 : 1 
                    }}
                    className={classnames({
                      active: this.state.activeTab3 === "4",
                    })}
                    onClick={() => {
                      if (!transaction?.isInvestor) {
                        this.toggle3("6");
                      }
                    }}
                  >
                    Deal Checklist
                  </NavLink>
                </NavItem> */}
                 
                  <NavItem>
                  <NavLink
                    style={{ 
                      cursor: transaction?.isInvestor ? "not-allowed" : "pointer", 
                      pointerEvents: transaction?.isInvestor ? "none" : "auto", 
                      opacity: transaction?.isInvestor ? 0.1 : 1 
                    }}
                    className={classnames({
                      active: this.state.activeTab3 === "4",
                    })}
                    onClick={() => {
                      if (!transaction?.isInvestor) {
                        this.toggle3("4");
                      }
                    }}
                  >
                    Client Checklist
                  </NavLink>
                </NavItem>
                 
                </Nav>
                <TabContent
                  activeTab={this.state.activeTab3}
                  className="p-3 text-muted"
                >
                  <TabPane tabId="1">
                    <Formik
                      enableReinitialize={true}
                      initialValues={{
                        clientEngagementForId: transaction?.clientEngagementId || "",

                        contactName: transaction?.contactName || "",
                        contactAddress: transaction?.contactAddress || "",
                        clientEngagementStatus: transaction?.clientEngagementStatus || "",
                        commissionTypeId: transaction?.commissionTypeId || "",
                        commissionValue: transaction?.commissionValue || 0,
                        endDate: transaction?.endDate || null,
                        startDate: transaction?.startDate || null,
                        propertyAddress: transaction?.propertyAddress || "",
                        transactionAmount: transaction?.transactionAmount,
                       
                      }}
                      validationSchema={Yup.object().shape({
                        contactName: Yup.string().required("Name is required"),
                        startDate: Yup.date().nullable().required("Start date is required"),
                        endDate: Yup.date()
                          .nullable()
                          .min(Yup.ref("startDate"), "End date cannot be before start date"),
                        transactionAmount: Yup.number()
                          .typeError("Transaction amount must be a number")
                          .min(0, "Transaction amount must be greater than 0")
                          .required("Transaction amount is required"),
                        commissionValue: Yup.number()
                          .typeError("Commission value must be a number")
                          .min(0, "Commission value must be greater than 0")
                          .required("Commission value is required"),
                      })}
                      onSubmit={async (values, { setSubmitting }) => {
                        try {
                          toast.loading("Submitting data...");

                          const payload = {
                            ...values,
                            transactionAmount: parseInt(values.transactionAmount),
                            commissionTypeId: parseInt(values.commissionTypeId),
                            commissionValue: parseInt(values.commissionValue),
                            startDate: values.startDate ? values.startDate : null,
                            endDate: values.endDate ? values.endDate : null,
                          };

                          const obj = JSON.parse(localStorage.getItem("authUser"));
                          const token = obj?.resultData?.bearerToken;
                          const headers = {
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${token}`,
                          };

                          const response = await axios.post(
                            `${API_URL}ClientEngagement/UpdateClientDeal`,
                            payload,
                            { headers }
                          );

                          toast.dismiss();
                          if (response.data.success) {
                            toast.success("Deal Updated Successfully!");
                           
                          } else {
                            toast.error(response.data.validationErrors?.[0] || "An error occur#9d3881.");
                          }
                        } catch (error) {
                          toast.dismiss();
                          toast.error(error.response?.data || error.message);
                        } finally {
                          setSubmitting(false);
                        }
                      }}
                    >
                      {({ errors, touched, values, handleChange, setFieldValue }) => (
                        <Form className="needs-validation">
                          <Row>
                            <Col sm="6">
                              <FormGroup className="mb-3">
                                <Label htmlFor="startDate">{this.props.t("Start date")}</Label>
                                <InputGroup>
                                  <Flatpickr
                                    className={`form-control ${errors.startDate && touched.startDate ? "is-invalid" : ""}`}
                                    placeholder=""
                                    value={values.startDate}
                                    onChange={(value) => setFieldValue("startDate", value[0])}
                                    options={{
                                      altInput: true,
                                      altFormat: "F j, Y",
                                      dateFormat: "Y-m-d",
                                    }}
                                  />
                                  <div className="input-group-append">
                                    <span className="input-group-text">
                                      <i className="mdi mdi-clock-outline" />
                                    </span>
                                  </div>
                                </InputGroup>
                              </FormGroup>
                            </Col>
                            <Col sm="6">  <FormGroup className="mb-3">
                              <Label htmlFor="endDate">{this.props.t("End date")}</Label>
                              <InputGroup>
                                <Flatpickr
                                  className={`form-control ${errors.endDate && touched.endDate ? "is-invalid" : ""}`}
                                  placeholder=""
                                  value={values.endDate}
                                  onChange={(value) => setFieldValue("endDate", value[0])}
                                  options={{
                                    altInput: true,
                                    altFormat: "F j, Y",
                                    dateFormat: "Y-m-d",
                                  }}
                                />
                                <div className="input-group-append">
                                  <span className="input-group-text">
                                    <i className="mdi mdi-clock-outline" />
                                  </span>
                                </div>
                              </InputGroup>
                            </FormGroup></Col>
                          </Row>




                          <FormGroup className="mb-3">
                            <Label htmlFor="contactName">{this.props.t("Name")}</Label>
                            <SafeField type="text" name="contactName" className="form-control" />
                            <ErrorMessage name="contactName" component="div" className="invalid-feedback" />
                          </FormGroup>

                          <FormGroup className="mb-3">
                            <Label htmlFor="propertyAddress">{this.props.t("Address")}</Label>
                            <PlacesAutocomplete
                              value={values.propertyAddress}
                              onChange={(value) => setFieldValue("propertyAddress", value)}
                            >
                              {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                                <div>
                                  <input
                                    {...getInputProps({
                                      placeholder: "Enter Address...",
                                      className: "form-control",
                                    })}
                                  />
                                  <div className="">
                                    {loading ? <div>Loading...</div> : null}
                                    {suggestions.map((suggestion, i) => {
                                      const style = suggestion.active
                                        ? { backgroundColor: "#007BFF", color: "#fff", cursor: "pointer", padding: "10px" }
                                        : { backgroundColor: "#fff", cursor: "pointer", padding: "10px" };
                                      return (
                                        <div key={i} {...getSuggestionItemProps(suggestion, { style })}>
                                          {suggestion.description}
                                        </div>
                                      );
                                    })}
                                  </div>
                                </div>
                              )}
                            </PlacesAutocomplete>
                          </FormGroup>



                          <Row>
                            <Col sm="4">
                              <FormGroup className="mb-3">
                                <Label htmlFor="transactionAmount">{this.props.t("Price")}</Label>
                                <SafeField type="text" name="transactionAmount" className="form-control" />
                                <ErrorMessage name="transactionAmount" component="div" className="invalid-feedback" />
                              </FormGroup>
                            </Col>
                            <Col sm="4">
                              <FormGroup className="mb-3">
                                <Label htmlFor="commissionTypeId">{this.props.t("Commission Type")}</Label>
                                <SafeField as="select" name="commissionTypeId" className="form-control">
                                  <option value="">Select</option>
                                  <option value="3">Fixed</option>
                                  <option value="4">%</option>
                                </SafeField>
                                <ErrorMessage name="commissionTypeId" component="div" className="invalid-feedback" />
                              </FormGroup>
                            </Col>

                            <Col sm="4">
                              <FormGroup className="mb-3">
                                <Label htmlFor="commissionValue">{this.props.t("Commission Value")}</Label>
                                <SafeField type="text" name="commissionValue" className="form-control" />
                                <ErrorMessage name="commissionValue" component="div" className="invalid-feedback" />
                              </FormGroup>
                            </Col>
                          </Row>
                          <Col sm="12">
                            <FormGroup className="mb-3">
                              <Label htmlFor="dealNotes">Notes</Label>
                              <SafeField as="textarea" name="dealNotes" className="form-control" />
                              <ErrorMessage name="dealNotes" component="div" className="invalid-feedback" />
                            </FormGroup>
                          </Col>
                          <div>
                            <SaveButton>Submit</SaveButton>{" "}
                            {transaction?.clientEngagementStatus === 1 && (
                              <RsAdNew className="btn btn-add" iconClass="" onClick={() => this.deleteDeal(deal)}>Delete Deal</RsAdNew>
                            )}
                          </div>
                        </Form>
                      )}
                    </Formik>

                  </TabPane>
                  <TabPane tabId="5">
                    { transaction?.isBuyer ?  
                    <>
                  
                    <table className="table  deal-info-table">
                     
                      <tbody>
                          <tr>
                            <th scope="row">Deal Id : <span>{generatedDealId}</span></th>
                           
                            <th scope="row">Deal Type: 
                            <span>
                            {transaction?.isBuyer
                                    ? `Buyer${transaction?.buyerType ? ` - ${this.getBuyerType(transaction?.buyerType)}` : ""}`
                                    : ""}

                            {transaction?.isSeller
                              ? `Seller${transaction?.sellerType ? ` - ${this.getSellerType(transaction?.sellerType)}` : ""}`
                              : ""}
                            </span>
                            </th>
                          </tr>
                          <tr>
                            <th scope="row" colSpan={2}>Address:  <span>{transaction?.contactAddress}</span></th>
                            
                          </tr>
                          <tr>
                            <th scope="row" colSpan={2} style={{color:'#9d3881'}}>Agent Info</th>
                           
                          </tr>
                          <tr>
                            <th scope="row">Name: <span>{transaction?.agentName}</span></th>
                            
                            <th scope="row">Business Name: <span>{ transaction?.agentOfficeName }</span></th>
                           
                          </tr>
                          <tr>
                            <th scope="row">Phone: <span>{transaction?.agentMobile}</span></th>
                           
                            <th scope="row">Email: <span>{ transaction?.agentEmail }</span></th>
                           
                          </tr>
                          <tr>
                            <th scope="row" colSpan={2} style={{color:'#9d3881'}}>Client Info</th>
                          </tr>
                          <tr>
                            <th scope="row">Name: <span>{transaction?.clientName}</span></th>
                           
                            <th scope="row">Email: <span>{ transaction?.clientEmail}</span></th>
                          
                          </tr>
                          <tr>
                            <th scope="row">Primary Phone: <span>{transaction?.clientMobile}</span></th>
                           
                            <th scope="row">Secondary Phone: <span>{ transaction?.clientPhone}</span></th>
                           
                          </tr>
                       <tr>
                            <th scope="row" colSpan={4} style={{color:'#9d3881'}}>Listing Details</th>
                          </tr>     
                      <tr>
                        <th scope="row">MLS ID: <span>{buyerListing?.mlsId} {buyerListing?.mlsurl ? <span className="float-end"><a href={buyerListing?.mlsurl} target="_blank" rel="noreferrer"><i className="bx bx-link-external font-size-20"></i></a></span> : '' }</span></th>
                     
                         <th scope="row">Is Interested: <span>{buyerListing?.isInterested ? 'Yes' : 'No'}</span></th>
                      
                      </tr>
                    
                      <tr>
                        <th scope="row">Listing Price: <span>${buyerListing?.listedPrice}</span></th>
                       
                      
                        <th scope="row">Listing Type: <span>{buyerListing?.listingType}</span></th>
                        
                      </tr>
                      <tr>
                        <th scope="row">Bedroom : <span>{buyerListing?.listingBedroom}</span></th>
                       
                    
                        <th scope="row">Bathroom: <span>{buyerListing?.listingBedroom}</span></th>
                       
                      </tr>
                      <tr>
                        <th scope="row">Parking: <span>{buyerListing?.listingParking}</span></th>
                       
                     
                        <th scope="row">Sq. Ft: <span>{buyerListing?.listingSqFt}</span></th>
                      
                    </tr>
                    <tr>
                        <th scope="row">Address: <span>{buyerListing?.listingAddress}</span></th>
                     
                     
                        <th scope="row">City: <span>{buyerListing?.listingCity}</span></th>
                     
                      </tr>

                     
                      </tbody>
                    </table>

                     {transaction?.clientEngagementStatus === 1  && (
                              <RsAdNew className="btn btn-add" iconClass="" onClick={() => this.deleteDeal(deal)}>Delete Deal</RsAdNew>
                      )}
                    </>
                 : transaction?.isSeller ?
                 <>
                  

                    <table className="table  deal-info-table ">
                     
                     <tbody>
                         <tr>
                           <th scope="row">Deal Id: <span>{generatedDealId}</span></th>
                          
                           <th scope="row">Deal Type: 
                            <span>
                           {transaction?.isBuyer
                                   ? `Buyer${transaction?.buyerType ? ` - ${this.getBuyerType(transaction?.buyerType)}` : ""}`
                                   : ""}

                           {transaction?.isSeller
                             ? `Seller${transaction?.sellerType ? ` - ${this.getSellerType(transaction?.sellerType)}` : ""}`
                             : ""}
                             </span>
                           </th>
                         </tr>
                         <tr>
                           <th scope="row" colSpan={2}>Address : <span>{transaction?.contactAddress}</span></th>
                           
                         </tr>
                         <tr>
                           <th scope="row" colSpan={2} style={{color:'#9d3881'}}>Agent Info</th>
                          
                         </tr>
                         <tr>
                           <th scope="row">Name : <span>{transaction?.agentName}</span></th>
                          
                           <th scope="row">Business Name: <span>{ transaction?.agentOfficeName }</span></th>
                          
                         </tr>
                         <tr>
                           <th scope="row">Phone: <span>{transaction?.agentMobile}</span></th>
                          
                           <th scope="row">Email: <span>{ transaction?.agentEmail }</span></th>
                          
                         </tr>
                         <tr>
                           <th scope="row" colSpan={2} style={{color:'#9d3881'}}>Client Info</th>
                         </tr>
                         <tr>
                           <th scope="row">Name: <span>{transaction?.clientName}</span></th>
                          
                           <th scope="row">Email: <span>{ transaction?.clientEmail}</span></th>
                         
                         </tr>
                         <tr>
                           <th scope="row">Primary Phone: <span>{transaction?.clientMobile}</span></th>
                          
                           <th scope="row">Secondary Phone: <span>{ transaction?.clientPhone}</span></th>
                          
                         </tr>
                         <tr>
                          <th scope="row" colSpan={2} style={{color:'#9d3881'}}>Listing Detail</th>
                          </tr>
                           <tr>
                        <th scope="row">Listing Id: <span>{sellerListing?.clientListing?.mlsId} {sellerListing?.clientListing?.mlsurl ? <span className="float-end"><a href={sellerListing?.clientListing?.mlsurl} target="_blank" rel="noreferrer"><i className="bx bx-link-external font-size-20"></i></a></span> : '' }</span></th>
                       
                    
                        <th scope="row">Listing Price: <span>{ sellerListing?.clientListing?.salePrice ? '$'+sellerListing?.clientListing?.salePrice : '' }</span></th>
                       
                      </tr>
                      <tr>
                        <th scope="row">Showing Date: <span>{sellerListing?.showingDate ? <Moment format="DD MMM YYYY">{sellerListing?.showingDate}</Moment> : ''}</span></th>
                       
                     
                        <th scope="row">Start Time: <span>{sellerListing?.startTime ? <Moment format="hh:ss A">{sellerListing?.startTime}</Moment> : ''}</span></th>
                       
                     
                       
                      </tr>
                      <tr>
                         <th scope="row">End Time: <span>{sellerListing?.endTime ? <Moment format="hh:ss A">{sellerListing?.endTime}</Moment> : ''}</span></th>
                       
                        <th scope="row">Agent Name: <span>{sellerListing?.agentName}</span></th>
                       
                     </tr>
                      <tr>
                        <th scope="row">Agent Organization: <span>{sellerListing?.agentOrganization}</span></th>
                       
                     
                        <th scope="row">Agent Contact : <span>{sellerListing?.agentContact}</span></th>
                       
                       </tr>
                         <tr>
                        <th scope="row">Agent Email: <span>{sellerListing?.agentEmail}</span></th>
                      
                         <th scope="row"></th>
                       
                      </tr>
                     </tbody>
                     </table>

                      {transaction?.clientEngagementStatus === 1 && (
                              <RsAdNew className="btn btn-add" iconClass="" onClick={() => this.deleteDeal(deal)}>Delete Deal</RsAdNew>
                      )}
                     
                    </>
                  :
                  <>
                  

                  <table className="table  deal-info-table ">
                     
                     <tbody>
                         <tr>
                           <th scope="row">Deal Id: <span>{generatedDealId}</span></th>
                          
                           <th scope="row">Deal Type: <span>Investor</span></th>
                          
                            
                           
                         </tr>
                         <tr>
                           <th scope="row" colSpan={2}>Address : <span>{transaction?.contactAddress}</span></th>
                          
                         </tr>
                         <tr>
                           <th scope="row" colSpan={2} style={{color:'#9d3881'}}>Client Info (Principal applicant)</th>
                          
                         </tr>
                         <tr>
                           <th scope="row">Name:<span>{transaction?.clientName}</span></th>
                          
                           <th scope="row">Email: <span>{ transaction?.clientEmail}</span></th>
                          
                         </tr>
                         <tr>
                           <th scope="row">Primary Phone: <span>{transaction?.clientMobile}</span></th>
                          
                           <th scope="row">Secondary Phone: <span>{ transaction?.clientPhone}</span></th>
                          
                         </tr>
                         <tr>
                           <th scope="row" colSpan={2} style={{color:'#9d3881'}}>Client Info (Secondary)</th>
                         </tr>
                         <tr>
                           <th scope="row">Name: <span>{transaction?.secondaryClientName}</span></th>
                          
                           <th scope="row">Email: <span>{ transaction?.secondaryClientEmail}</span></th>
                          
                         </tr>
                         <tr>
                           <th scope="row">Primary Phone: <span>{transaction?.secondaryClientMobile}</span></th>
                          
                           <th scope="row">Secondary Phone: <span>{ transaction?.secondaryClientPhone}</span></th>
                          
                         </tr>
                    
                     <tr>
                           <th scope="row" colSpan={2} style={{color:'#9d3881'}}>Project Detail</th>
                         </tr>
                      <tr>
                        <th scope="row">Project Name: <span>{ investorListing?.project?.projectName }</span></th>
                       
                     
                        <th scope="row">Unit: <span>{ investorListing?.projects[0]?.selectedOptionText }</span></th>
                       
                      </tr>
                      <tr>
                        <th scope="row">Builder: <span>{ investorListing?.builder?.builderName }</span></th>
                       
                     
                        <th scope="row">Cost: <span>{investorListing?.projects[0]?.insideSqFt}</span></th>
                       
                      </tr>

                      <tr>
                        <th scope="row">Inside Sq.ft: <span>{investorListing?.projects[0]?.insideSqFt}</span></th>
                       
                     
                        <th scope="row">Outside Sq.ft: <span>{investorListing?.projects[0]?.outsideSqFt}</span></th>
                       
                      </tr>
                     {/* <tr>
                      <th scope="row" colSpan="2">Notes: <span>{investorListing?.notes}</span></th>
                     </tr> */}
                      </tbody>
                    </table>
                  </>
                  }

                  </TabPane>
                
                  <TabPane tabId="2">
                    <Formik
                      enableReinitialize={true}
                      initialValues={{

                        documentStorageType: 0,
                        clientEngagementId: transaction?.clientEngagementId,
                        agreementDocumentFromId: localStorage.getItem("userId"),
                        agreementDocumentToId: this.props.match.params.id,
                        agreementDocumentTitle: '',
                        agreementDocumentFrom: 'Realtor',
                        agreementDocumentTo: 'Client',
                        agreementDocumentLink: '',
                        agreementDocumentTypeId: 0,
                        agreementDocumentStorageType: 0,
                        agentId: localStorage.getItem('userId'),
                        isActive: true,
                        isUrgent: false,
                        sendNotification: false
                      }}
                      validationSchema={Yup.object().shape({
                        agreementDocumentLink: Yup.string()
                          .when("documentStorageType", {
                            is: 1,
                            then: Yup.string().required("Document link is required").url("Invalid URL format"),
                            //otherwise: Yup.string().not.required(),
                          }),
                        agreementDocumentTitle: Yup.string().required("This is required")
                      })}
                      onSubmit={this.handleDocumentSubmit}
                    >
                      {({
                        errors,
                        touched,
                        values,
                        handleChange,
                        setFieldValue,
                      }) => (
                        <Form className="needs-validation">
                          {/* <FormGroup className="mb-3"> */}
                          <Row>
                            <Col sm="12">
                              <div className="btn-group" role="group">
                                <SafeField
                                  type="radio"
                                  className="btn-check"
                                  name="documentStorageType"
                                  id="documentStorageType1"
                                  autoComplete="off"
                                  value={0}
                                  onChange={() => setFieldValue("documentStorageType", 0)}
                                />
                                <label
                                  className="btn btn-outline-secondary"
                                  htmlFor="documentStorageType1"
                                >
                                  Upload File
                                </label>

                                <SafeField
                                  type="radio"
                                  className="btn-check"
                                  name="documentStorageType"
                                  id="documentStorageType2"
                                  autoComplete="off"
                                  value={1}
                                  onChange={() => setFieldValue("documentStorageType", 1)}
                                />
                                <label
                                  className="btn btn-outline-secondary"
                                  htmlFor="documentStorageType2"
                                >
                                  Add Link
                                </label>
                              </div>
                            </Col>
                          </Row>

                          {values.documentStorageType === 0 && (

                            <Row>
                              <Col sm="5">
                                <FormGroup className="mb-3">
                                  <Label htmlFor="agreementDocumentTitle">{this.props.t("Title")}</Label>
                                  <SafeField
                                    name="agreementDocumentTitle"
                                    onChange={handleChange}
                                    type="text"
                                    className={
                                      "form-control" +
                                      (errors.agreementDocumentTitle && touched.agreementDocumentTitle
                                        ? " is-invalid"
                                        : "")
                                    }
                                    id="agreementDocumentTitle"
                                  />
                                  <ErrorMessage
                                    name="agreementDocumentTitle"
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </FormGroup>
                              </Col>
                              <Col sm="5">
                                <FormGroup className="mb-3">
                                  <Label htmlFor="agreementDocumentLink">{this.props.t("Upload Document")}</Label>
                                  <input
                                    type="file"
                                    className="form-control"
                                    onChange={event => this.handleFileChange(event, setFieldValue)}
                                  />
                                  <small className="help">Maximum file size: 5MB (Upload only Pdf, Doc, JPG, PNG)</small>
                                </FormGroup>
                              </Col>
                              <Col sm="2">
                                <div style={{ marginTop: 30 }}></div>
                                 { fileUploaded ?  <SaveButton>Upload</SaveButton> : <button className="btn btn-save" disabled>Upload</button> }  
                                
                              </Col>
                            </Row>

                          )}
                          {values.documentStorageType === 1 && (
                            <Row>
                              <Col sm="5">
                                <FormGroup className="mb-3">
                                  <Label htmlFor="agreementDocumentTitle">{this.props.t("Title")}</Label>
                                  <SafeField
                                    name="agreementDocumentTitle"
                                    onChange={handleChange}
                                    type="text"
                                    className={
                                      "form-control" +
                                      (errors.agreementDocumentTitle && touched.agreementDocumentTitle
                                        ? " is-invalid"
                                        : "")
                                    }
                                    id="agreementDocumentTitle"
                                  />
                                  <ErrorMessage
                                    name="agreementDocumentTitle"
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </FormGroup>
                              </Col>
                              <Col sm="5">
                                <FormGroup className="mb-3">
                                  <Label htmlFor="documentLink">{this.props.t("Link")}</Label>
                                  <SafeField
                                    name="agreementDocumentLink"
                                    onChange={handleChange}
                                    type="text"
                                    className={
                                      "form-control" +
                                      (errors.agreementDocumentLink && touched.agreementDocumentLink
                                        ? " is-invalid"
                                        : "")
                                    }
                                    id="documentLink"
                                  />
                                  <ErrorMessage
                                    name="agreementDocumentLink"
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </FormGroup>
                              </Col>
                              <Col sm="2">
                                <div style={{ marginTop: 30 }}></div>
                                <SaveButton>Submit</SaveButton>
                              </Col>
                            </Row>

                          )}





                        </Form>
                      )}
                    </Formik>


                    <table className="align-middle mb-0 table">
                      <thead>
                        <tr>
                          <th>Date</th>
                          <th>Title</th>
                          <th>View</th>

                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        {dealDocuments?.map((doc, i) => (
                          <tr key={i}>
                            <td>{doc.createdDate? <Moment format="DD MMM YYYY">{doc.createdDate }</Moment>: '' }</td>
                            <td>{doc.agreementDocumentTitle}</td>
                            <td><a href={doc.agreementDocumentLink} target="_blank" rel="noopener noreferrer">View</a></td>
                            <td><ActionDelete onClick={() => this.handleDeleteDoc(doc)} /></td>
                          </tr>
                        ))}
                      </tbody>

                    </table>
                  </TabPane>
                  <TabPane tabId="3">
                    {(mortgageContact || legalContact) ? (
                      <>
                        {mortgageContact && (
                          <>
                            <h4>Mortgage Contact</h4>
                            <table className="align-middle mb-0 table">
                              <tbody>
                                <tr>
                                  <th scope="row">Name</th>
                                  <td>{`${mortgageContact?.title} ${mortgageContact?.contactFName} ${mortgageContact?.contactLName}`}</td>
                                </tr>
                                <tr>
                                  <th scope="row">Organization Name</th>
                                  <td>{mortgageContact?.organizationName || ''}</td>
                                </tr>
                                <tr>
                                  <th scope="row">Address</th>
                                  <td>{mortgageContact?.clientProfessionalContactAddress?.fullAddress || ''}</td>
                                </tr>
                                <tr>
                                  <th scope="row">Email </th>
                                  <td>{mortgageContact?.primaryContact?.email || ''}</td>
                                </tr>
                                <tr>
                                  <th scope="row">Mobile  </th>
                                  <td>{mortgageContact?.primaryContact?.mobile || ''}</td>
                                </tr>
                                <tr>
                                  <th scope="row">Secondary Phone  </th>
                                  <td>{mortgageContact?.primaryContact?.phone || ''} {mortgageContact?.primaryContact?.phoneExt || ''}</td>
                                </tr>
                                <tr>
                                  <th scope="row">Notes</th>
                                  <td>{mortgageContact?.notes || ''}</td>
                                </tr>
                              </tbody>
                            </table>
                          </>
                        )}
                        {legalContact && (
                          <>
                            <h4>Legal Contact</h4>
                            <table className="align-middle mb-0 table">
                              <tbody>
                                <tr>
                                  <th scope="row">Name</th>
                                  <td>{`${legalContact?.title} ${legalContact?.contactFName} ${legalContact?.contactLName}`}</td>
                                </tr>
                                <tr>
                                  <th scope="row">Organization Name</th>
                                  <td>{legalContact?.organizationName || ''}</td>
                                </tr>
                                <tr>
                                  <th scope="row">Address</th>
                                  <td>{legalContact?.clientProfessionalContactAddress?.fullAddress || ''}</td>
                                </tr>
                                <tr>
                                  <th scope="row">Email </th>
                                  <td>{legalContact?.primaryContact?.email || ''}</td>
                                </tr>
                                <tr>
                                  <th scope="row">Mobile  </th>
                                  <td>{legalContact?.primaryContact?.mobile || ''}</td>
                                </tr>
                                <tr>
                                  <th scope="row">Secondary Phone  </th>
                                  <td>{legalContact?.primaryContact?.phone || ''} {legalContact?.primaryContact?.phoneExt || ''}</td>
                                </tr>
                                <tr>
                                  <th scope="row">Notes</th>
                                  <td>{legalContact?.notes || ''}</td>
                                </tr>
                              </tbody>
                            </table>
                          </>
                        )}
                      </>
                    ) : (
                      <p>Not Provided</p>
                    )}
                  </TabPane>
                  <TabPane tabId="4">
                    <Formik
                      enableReinitialize={true}
                      initialValues={{
                        selectedTasks: this.state.selectedChecklistIds || [],

                      }}
                      validationSchema={Yup.object().shape({})}
                      onSubmit={(values) => {
                        const closingCheckLists = (values.selectedTasks || []).map((taskId) => ({
                          clientClosingCheckListId: parseInt(taskId, 10),
                          clientListingId: 0,
                          clientDealId: parseInt(transaction?.clientEngagementId),
                          clientId: parseInt(localStorage.getItem("userId")),
                          agentId: parseInt(localStorage.getItem("agentId")),
                          status: true,
                          isActive: true,
                        }));
                        // toast.loading("Please wait...");
                        const payload = transaction?.isBuyer
                          ? { buyerClosingCheckLists: closingCheckLists }
                          : { sellerClosingCheckLists: closingCheckLists };

                        const obj = JSON.parse(localStorage.getItem("authUser"));
                        const token = obj?.resultData?.bearerToken;
                        toast.loading("Please wait...")
                        const url = transaction?.isBuyer ? `${API_URL}ClientBuyerClosingCheckList/bulkadd` : `${API_URL}ClientSellerClosingCheckList/bulkadd`;
                        fetch(url, {
                          method: "POST",
                          headers: {
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${token}`,
                          },
                          body: JSON.stringify(payload),
                        })
                          .then((response) => {
                            if (!response.ok) {
                              throw new Error(`HTTP error! Status: ${response.status}`);
                            }
                            return response.json();
                          })
                          .then((data) => {
                            
                            toast.dismiss();
                            toast.success("Checklist updated successfully!");
                          })
                          .catch((error) => {
                            console.error("Error:", error);
                            toast.dismiss();
                            toast.error(`Error updating checklist: ${error.message}`);
                          });


                      }}
                    >
                      {({ values, setFieldValue }) => (
                        <Form className="needs-validation">
                          <div className="accordion accordion-flush" id="accordionFlushExample">
                            {groupedChecklist && Object.keys(groupedChecklist).length > 0 ? (
                              <>
                                {Object.entries(groupedChecklist).map(([category, tasks], index) => (
                                  <div className="accordion-item" key={category}>
                                    <h2 className="accordion-header" id={`heading-${index}`}>
                                      <button
                                        className={`accordion-button fw-medium ${this.state.activeCategories[category] ? "" : "collapsed"}`}
                                        type="button"
                                        onClick={() => this.toggleCategory(category)}
                                        style={{ cursor: "pointer" }}
                                      >
                                        {category}
                                      </button>
                                    </h2>

                                    <Collapse isOpen={this.state.activeCategories[category]} className="accordion-collapse">
                                      <div className="accordion-body">
                                        {tasks.length > 0 ? (
                                          <Row>
                                            {tasks.map((task) => (
                                              <Col md="12" key={task.id}>
                                                <FormGroup className="mb-3">
                                                  <input
                                                    name="selectedTasks"
                                                    className="form-check-input me-2"
                                                    type="checkbox"
                                                    id={`task_${task.id}`}
                                                    checked={values.selectedTasks.includes(task.id)}
                                                    onChange={(e) => {
                                                      const checked = e.target.checked;
                                                      setFieldValue(
                                                        "selectedTasks",
                                                        checked
                                                          ? [...values.selectedTasks, task.id]
                                                          : values.selectedTasks.filter((id) => id !== task.id)
                                                      );
                                                    }}
                                                  />
                                                  <Label htmlFor={`task_${task.id}`} className="form-check-label">
                                                    {task.checkListTask}
                                                  </Label>
                                                </FormGroup>
                                              </Col>
                                            ))}
                                          </Row>
                                        ) : (
                                          <p className="text-muted">No tasks available</p>
                                        )}
                                      </div>
                                    </Collapse>
                                  </div>
                                ))}
                              </>
                            ) : null}
                          </div>
                        </Form>
                      )}
                    </Formik>
                  </TabPane>
                    <TabPane tabId="6">
                    
                    { transaction?.isBuyer ?  
                    <>
                    <Formik
                      enableReinitialize={true}
                      initialValues={{
                      conditions: newdealChecklists
                            ? newdealChecklists
                                .filter(c => c.status === true)
                                .map(c => c.clientDealCheckListId.toString())
                            : []
                        }}
                      validationSchema={Yup.object().shape({})}
                        onSubmit={(values) => {
   
                       const payload = {
                            buyerDealCheckLists: this.state.alldealChecklists.map((condition) => {
                              const existingItem = newdealChecklists.find(
                                (item) => item.clientDealCheckListId === condition.id
                              );

                              return {
                                id: existingItem ? existingItem.id : 0, 
                                clientDealCheckListStateId: existingItem ? existingItem.clientDealCheckListStateId : "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                                clientDealCheckListId: condition.id,
                                clientListingId: 0,
                                clientDealId: parseInt(transaction?.clientEngagementId),
                                clientId: parseInt(this.props.match.params.id),
                                agentId: parseInt(localStorage.getItem("userId")) || 0,
                                status: values.conditions.includes(condition.id.toString()),
                                isActive: true,
                              };
                            }),
                          };
                        const obj = JSON.parse(localStorage.getItem("authUser"));
                        const token = obj?.resultData?.bearerToken;
                        toast.loading("Please wait...")
                        fetch(`${API_URL}ClientBuyerDealCheckList/bulkadd`, {
                          method: "POST",
                          headers: {
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${token}`,
                          },
                          body: JSON.stringify(payload),
                        })
                          .then((response) => {
                            if (!response.ok) {
                              throw new Error(`HTTP error! Status: ${response.status}`);
                            }
                            return response.json();
                          })
                          .then((data) => {
                            
                            toast.dismiss();
                            toast.success("Deal Checklist added successfully!");
                          })
                          .catch((error) => {
                            console.error("Error:", error);
                            toast.dismiss();
                            toast.error(`Error updating checklist: ${error.message}`);
                          });


                      }}
                      
                    >
                      {({ values, setFieldValue }) => (
                        <Form className="needs-validation">
                    <Row>
                    {map(this.state.alldealChecklists, (checklist, index) => (
                      <Col sm="12" key={index}>
                        
                        <FormGroup className="mb-3 form-check">
                        <SafeField
                          type="checkbox"
                          name="conditions"
                          value={checklist.id.toString()}
                          className="form-check-input"
                          id={`condition-${index}`}
                        />
                        <label className="form-check-label" htmlFor={`condition-${index}`}>
                          {checklist.checkListTask	}
                        </label>
                        </FormGroup>
                      </Col>
                    
                    ))}
                    </Row>

                    <SaveButton>Submit</SaveButton>
                    </Form>
                     )}
                </Formik>
                    
                    </>
                    : transaction?.isSeller ?
                    <>
                      <Formik
                      enableReinitialize={true}
                      initialValues={{
                      conditions: newdealChecklists
                            ? newdealChecklists
                                .filter(c => c.status === true)
                                .map(c => c.clientDealCheckListId.toString())
                            : []
                        }}
                      validationSchema={Yup.object().shape({})}
                        onSubmit={(values) => {
   
                       const payload = {
                            sellerDealCheckLists: this.state.alldealChecklists.map((condition) => {
                              const existingItem = newdealChecklists.find(
                                (item) => item.clientDealCheckListId === condition.id
                              );

                              return {
                                id: existingItem ? existingItem.id : 0, 
                                clientDealCheckListStateId: existingItem ? existingItem.clientDealCheckListStateId : "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                                clientDealCheckListId: condition.id,
                                clientListingId: 0,
                                clientDealId: parseInt(transaction?.clientEngagementId),
                                clientId: parseInt(this.props.match.params.id),
                                agentId: parseInt(localStorage.getItem("userId")) || 0,
                                status: values.conditions.includes(condition.id.toString()),
                                isActive: true,
                              };
                            }),
                          };
                        const obj = JSON.parse(localStorage.getItem("authUser"));
                        const token = obj?.resultData?.bearerToken;
                        toast.loading("Please wait...")
                        fetch(`${API_URL}ClientSellerDealCheckList/bulkadd`, {
                          method: "POST",
                          headers: {
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${token}`,
                          },
                          body: JSON.stringify(payload),
                        })
                          .then((response) => {
                            if (!response.ok) {
                              throw new Error(`HTTP error! Status: ${response.status}`);
                            }
                            return response.json();
                          })
                          .then((data) => {
                            
                            toast.dismiss();
                            toast.success("Deal Checklist added successfully!");
                          })
                          .catch((error) => {
                            console.error("Error:", error);
                            toast.dismiss();
                            toast.error(`Error updating checklist: ${error.message}`);
                          });


                      }}
                      
                    >
                      {({ values, setFieldValue }) => (
                        <Form className="needs-validation">
                    <Row>
                    {map(this.state.alldealChecklists, (checklist, index) => (
                      <Col sm="12" key={index}>
                        
                        <FormGroup className="mb-3 form-check">
                        <SafeField
                          type="checkbox"
                          name="conditions"
                          value={checklist.id.toString()}
                          className="form-check-input"
                          id={`condition-${index}`}
                        />
                        <label className="form-check-label" htmlFor={`condition-${index}`}>
                          {checklist.checkListTask	}
                        </label>
                        </FormGroup>
                      </Col>
                    
                    ))}
                    </Row>

                    <SaveButton>Submit</SaveButton>
                    </Form>
                     )}
                </Formik>
                    </>
                    :
                      <>
                      
                      </>
                  }
                    </TabPane>

                     <TabPane tabId="7">
                    { transaction?.isBuyer ?  
                    <>
                    <Formik
                      enableReinitialize={true}
                      initialValues={{
                      conditions: newdealChecklists
                            ? newdealChecklists
                                .filter(c => c.status === true)
                                .map(c => c.clientDealCheckListId.toString())
                            : []
                        }}
                      validationSchema={Yup.object().shape({})}
                        onSubmit={(values) => {
   
                       const payload = {
                            buyerDealCheckLists: this.state.alldealChecklists.map((condition) => {
                              const existingItem = newdealChecklists.find(
                                (item) => item.clientDealCheckListId === condition.id
                              );

                              return {
                                id: existingItem ? existingItem.id : 0, 
                                clientDealCheckListStateId: existingItem ? existingItem.clientDealCheckListStateId : "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                                clientDealCheckListId: condition.id,
                                clientListingId: 0,
                                clientDealId: parseInt(transaction?.clientEngagementId),
                                clientId: parseInt(this.props.match.params.id),
                                agentId: parseInt(localStorage.getItem("userId")) || 0,
                                status: values.conditions.includes(condition.id.toString()),
                                isActive: true,
                              };
                            }),
                          };
                        const obj = JSON.parse(localStorage.getItem("authUser"));
                        const token = obj?.resultData?.bearerToken;
                        toast.loading("Please wait...")
                        fetch(`${API_URL}ClientBuyerDealCheckList/bulkadd`, {
                          method: "POST",
                          headers: {
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${token}`,
                          },
                          body: JSON.stringify(payload),
                        })
                          .then((response) => {
                            if (!response.ok) {
                              throw new Error(`HTTP error! Status: ${response.status}`);
                            }
                            return response.json();
                          })
                          .then((data) => {
                            
                            toast.dismiss();
                            toast.success("Deal Checklist added successfully!");
                          })
                          .catch((error) => {
                            console.error("Error:", error);
                            toast.dismiss();
                            toast.error(`Error updating checklist: ${error.message}`);
                          });


                      }}
                      
                    >
                      {({ values, setFieldValue }) => (
                        <Form className="needs-validation">
                    <table className="table  deal-info-table">
                     
                     <tbody>
                      <tr>
                                                  <th scope="row" colSpan={3} style={{color:'#000'}}><h5 style={{fontSize:16, color:'#000'}}>Deal Checklist</h5></th>
                                                </tr>
                                                  <tr>
                                                  <td colSpan={3}>
                                                    {map(this.state.alldealChecklists, (checklist, index) => (
                                                      <div className="form-check form-check-inline" key={index}>
                                                        <SafeField
                                                          type="checkbox"
                                                          name="conditions"
                                                          value={checklist.id.toString()}
                                                          className="form-check-input"
                                                          id={`condition-deal-${index}`}
                                                        />
                                                        <label
                                                          className="form-check-label"
                                                          htmlFor={`condition-deal-${index}`}
                                                        >
                                                          {checklist.checkListTask}
                                                        </label>
                                                      </div>
                                                    ))}
                                                  </td>
                                                </tr>
                                                  <tr>
                           <th scope="row" colSpan={3}><h6 style={{color:'#000', fontSize:16}}>Offer details</h6></th>
                           
                         </tr>
                         <tr>
                          <th scope="row">
                            Offer status: 
                          <span>{clientBuyerOffer?.statusTitle}</span></th>
                           <th scope="row">Deal Id: <span>{generatedDealId}</span></th>
                          
                           <th scope="row">Id/MLS#: 
                            <span>
                           {clientBuyerOffer?.mlsId}
                             </span>
                           </th>
                         </tr>
                          <tr>
                           <th scope="row" colSpan={3}>Property address : {clientBuyerOffer?.propertyAddress}</th>
                           
                         </tr>
                          <tr>
                            <th scope="row" colSpan={3}><h6 style={{color:'#000'}}>Condition/clauses</h6></th>
                          
                         </tr>
                          <tr>
                            <th scope="row" colSpan={3}>
                              <div>
                                {clientBuyerOffer?.clientDealConditionStates?.map((condition, index) => (
                                <div className="form-check form-check-inline" key={index}>
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                      id={`condition-${index}`}
                                    value=""
                                    checked={condition.status}
                                  />
                                  <label className="form-check-label" htmlFor={`condition-${index}`}>
                                      {condition.clientDealConditionTitle || `Condition ${condition.clientDealConditionId}`}
                                     </label>
                                </div>
                                ))}
                              </div>

                            </th>
                          
                         </tr>
                         
                          <tr>
                          <th scope="row">
                            Receive date: 
                          <span>{clientBuyerOffer?.offerDate ? <Moment format="DD MMM YYYY">{clientBuyerOffer?.offerDate}</Moment> : ''}</span></th>
                           <th scope="row">Offer Price: <span>
                               <CurrencyFormat
                                    value={clientBuyerOffer?.offerPrice || 0}
                                    displayType={'text'}
                                    thousandSeparator={true}
                                    prefix={transaction?.currencyCode ? transaction?.currencyCode + " " : "$"}
                                    decimalScale={2}
                                    fixedDecimalScale={true}
                                  />
                            
                            
                           </span></th>
                          
                           <th scope="row">Deposit amount: 
                            <span>
                               <CurrencyFormat
                                    value={clientBuyerOffer?.deposit || 0}
                                    displayType={'text'}
                                    thousandSeparator={true}
                                    prefix={transaction?.currencyCode ? transaction?.currencyCode + " " : "$"}
                                    decimalScale={2}
                                    fixedDecimalScale={true}
                                  />
                                
                             </span>
                           </th>
                         </tr>

                          <tr>
                          <th scope="row">
                            Closing date: 
                          <span>{clientBuyerOffer?.closingDate ? <Moment format="DD MMM YYYY">{clientBuyerOffer?.closingDate}</Moment> : ''}</span></th>
                           <th scope="row">Offer expiry date/time:  <span>{clientBuyerOffer?.offerExpiry ? <Moment format="DD MMM YYYY">{clienclientBuyerOffertSellerOffer?.offerExpiry}</Moment> : ''}</span></th>
                          
                           <th scope="row">
                           </th>
                         </tr>
                            {clientBuyerOffer?.notes && (
                              <>
                          <tr>
                            <th scope="row" colSpan={3}><h6 style={{color:'#000'}}>Special requests/clauses/conditions/notes</h6></th>
                          
                         </tr>
                          <tr>
                            <th scope="row" colSpan={3}><span>{clientBuyerOffer?.notes}</span></th>
                          
                         </tr>
                         </>
                            )}
                           <tr>
                            <th scope="row" colSpan={3}><h6 style={{color:'#000', fontSize:16}}>Listing Agent</h6></th>
                          
                         </tr>
                         <tr>
                           <th scope="row">Name : <span>{clientBuyerOffer?.agentName}</span></th>
                          
                           <th scope="row">Business Name: <span>{ clientBuyerOffer?.agentOfficeName }</span></th>
                           <th scope="row"></th>
                          
                         </tr>
                         <tr>
                           <th scope="row">Phone: <span>{clientBuyerOffer?.agentMobile}</span></th>
                          
                           <th scope="row">Email: <span>{ clientBuyerOffer?.agentEmail }</span></th>
                           <th scope="row"></th>
                          
                         </tr>
                      
                          <tr>
                            <th scope="row" colSpan={4} style={{color:'#000'}}><h6 style={{color:'#000', fontSize:16}}>Listing Details</h6></th>
                          </tr>     
                      <tr>
                        <th scope="row">MLS ID: <span>{buyerListing?.mlsId} {buyerListing?.mlsurl ? <span className="float-end"><a href={buyerListing?.mlsurl} target="_blank" rel="noreferrer"><i className="bx bx-link-external font-size-20"></i></a></span> : '' }</span></th>
                     
                         <th scope="row">Listing Price: <span>${buyerListing?.listedPrice}</span></th>

                          <th scope="row">Bedroom : <span>{buyerListing?.listingBedroom}</span></th>
                      
                      </tr>
                    
                      <tr>
                       
                       
                      
                       
                        
                      </tr>
                      <tr>
                        
                       
                    
                        <th scope="row">Bathroom: <span>{buyerListing?.listingBedroom}</span></th>
                        <th scope="row">Parking: <span>{buyerListing?.listingParking}</span></th>
                         <th scope="row">Sq. Ft: <span>{buyerListing?.listingSqFt}</span></th>
                       
                      </tr>
                     
                  
                     </tbody>
                     </table>
                     <SaveButton>Submit</SaveButton> <RsLink onClick={this.toggleManage}>Close</RsLink>
</Form>
                      )}
                    </Formik>
                    
                    </>
                 : transaction?.isSeller ?
                 <>
                  
                    <Formik
                      enableReinitialize={true}
                      initialValues={{
                      conditions: newdealChecklists
                            ? newdealChecklists
                                .filter(c => c.status === true)
                                .map(c => c.clientDealCheckListId.toString())
                            : []
                        }}
                      validationSchema={Yup.object().shape({})}
                        onSubmit={(values) => {
   
                       const payload = {
                            sellerDealCheckLists: this.state.alldealChecklists.map((condition) => {
                              const existingItem = newdealChecklists.find(
                                (item) => item.clientDealCheckListId === condition.id
                              );

                              return {
                                id: existingItem ? existingItem.id : 0, 
                                clientDealCheckListStateId: existingItem ? existingItem.clientDealCheckListStateId : "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                                clientDealCheckListId: condition.id,
                                clientListingId: 0,
                                clientDealId: parseInt(transaction?.clientEngagementId),
                                clientId: parseInt(this.props.match.params.id),
                                agentId: parseInt(localStorage.getItem("userId")) || 0,
                                status: values.conditions.includes(condition.id.toString()),
                                isActive: true,
                              };
                            }),
                          };
                        const obj = JSON.parse(localStorage.getItem("authUser"));
                        const token = obj?.resultData?.bearerToken;
                        toast.loading("Please wait...")
                        fetch(`${API_URL}ClientSellerDealCheckList/bulkadd`, {
                          method: "POST",
                          headers: {
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${token}`,
                          },
                          body: JSON.stringify(payload),
                        })
                          .then((response) => {
                            if (!response.ok) {
                              throw new Error(`HTTP error! Status: ${response.status}`);
                            }
                            return response.json();
                          })
                          .then((data) => {
                            
                            toast.dismiss();
                            toast.success("Deal Checklist added successfully!");
                          })
                          .catch((error) => {
                            console.error("Error:", error);
                            toast.dismiss();
                            toast.error(`Error updating checklist: ${error.message}`);
                          });


                      }}
                      
                    >
                      {({ values, setFieldValue }) => (
                        <Form className="needs-validation">   
                    <table className="table  deal-info-table">
                     
                     <tbody>
                       <tr>
                      <th scope="row" colSpan={3} style={{color:'#000'}}><h5 style={{fontSize:16, color:'#000'}}>Deal Checklist</h5></th>
                    </tr>
                      <tr>
                      <td colSpan={3}>
                        {map(this.state.alldealChecklists, (checklist, index) => (
                          <div className="form-check form-check-inline" key={index}>
                            <SafeField
                              type="checkbox"
                              name="conditions"
                              value={checklist.id.toString()}
                              className="form-check-input"
                              id={`condition-deal-${index}`}
                            />
                            <label
                              className="form-check-label"
                              htmlFor={`condition-deal-${index}`}
                            >
                              {checklist.checkListTask}
                            </label>
                          </div>
                        ))}
                      </td>
                    </tr>
                      <tr>
                      <th scope="row" colSpan={3} style={{color:'#000'}}><h5 style={{fontSize:16, color:'#000'}}>Offer  Detail</h5></th>
                    </tr>
                         <tr>
                          <th scope="row">
                            Offer status: 
                          <span>{clientSellerOffer?.statusTitle}</span></th>
                           <th scope="row">Deal Id: <span>{generatedDealId}</span></th>
                          
                           <th scope="row">Id/MLS#: 
                            <span>
                           {sellerListing?.clientListing?.mlsId}
                             </span>
                           </th>
                         </tr>
                        
                          <tr>
                          <th scope="row">
                            Receive date: 
                          <span>{clientSellerOffer?.offerDate ? <Moment format="DD MMM YYYY">{clientSellerOffer?.offerDate}</Moment> : ''}</span></th>
                           <th scope="row">Offer Price: <span>
                               <CurrencyFormat
                                    value={clientSellerOffer?.offerPrice || 0}
                                    displayType={'text'}
                                    thousandSeparator={true}
                                    prefix={transaction?.currencyCode ? transaction?.currencyCode + " " : "$"}
                                    decimalScale={2}
                                    fixedDecimalScale={true}
                                  />
                            
                            
                           </span></th>
                          
                           <th scope="row">Deposit amount: 
                            <span>
                               <CurrencyFormat
                                    value={clientSellerOffer?.deposit || 0}
                                    displayType={'text'}
                                    thousandSeparator={true}
                                    prefix={transaction?.currencyCode ? transaction?.currencyCode + " " : "$"}
                                    decimalScale={2}
                                    fixedDecimalScale={true}
                                  />
                                
                             </span>
                           </th>
                         </tr>

                          <tr>
                          <th scope="row">
                            Closing date: 
                          <span>{clientSellerOffer?.closingDate ? <Moment format="DD MMM YYYY">{clientSellerOffer?.closingDate}</Moment> : ''}</span></th>
                           <th scope="row">Offer expiry date/time:  <span>{clientSellerOffer?.offerExpiry ? <Moment format="DD MMM YYYY">{clientSellerOffer?.offerExpiry}</Moment> : ''}</span></th>
                          
                           <th scope="row">
                           </th>
                         </tr>
                         <tr>
                            <th scope="row" colSpan={3}><h6 style={{color:'#000'}}>Condition/clauses</h6></th>
                          
                         </tr>
                          <tr>
                            <th scope="row" colSpan={3}>
                              <div>
                                {clientSellerOffer?.clientDealConditionStates?.map((condition, index) => (
                                <div className="form-check form-check-inline" key={index}>
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                      id={`condition-${index}`}
                                    value=""
                                    checked={condition.status}
                                  />
                                  <label className="form-check-label" htmlFor={`condition-${index}`}>
                                      {condition.clientDealConditionTitle || `Condition ${condition.clientDealConditionId}`}
                                     </label>
                                </div>
                                ))}
                              </div>

                            </th>
                          
                         </tr>
                           {clientSellerOffer?.notes && (
                              <>
                          <tr>
                            <th scope="row" colSpan={3}><h6 style={{color:'#000'}}>Special requests/clauses/conditions/notes</h6></th>
                          
                         </tr>
                          <tr>
                            <th scope="row" colSpan={3}><span>{clientSellerOffer?.notes}</span></th>
                          
                         </tr>
                         </>
                            )}
                          <tr>
                           <th scope="row">Buyer Name : <span>{clientSellerOffer?.partyName}</span></th>
                          
                           <th scope="row"></th>
                           <th scope="row"></th>
                          
                         </tr>
                           <tr>
                            <th scope="row" colSpan={3}><h6 style={{color:'#000',  fontSize:16}}>Agent Info</h6></th>
                          
                         </tr>
                         <tr>
                           <th scope="row">Name : <span>{clientSellerOffer?.agentName}</span></th>
                          
                           <th scope="row">Business Name: <span>{ clientSellerOffer?.agentOfficeName }</span></th>
                           <th scope="row"></th>
                          
                         </tr>
                         <tr>
                           <th scope="row">Phone: <span>{clientSellerOffer?.agentMobile}</span></th>
                          
                           <th scope="row">Email: <span>{ clientSellerOffer?.agentEmail }</span></th>
                           <th scope="row"></th>
                          
                         </tr>
                      
                        
                     </tbody>
                     </table>
                      <SaveButton>Submit</SaveButton> <RsLink onClick={this.toggleManage}>Close</RsLink>
</Form>
                      )}
                    </Formik>
                    
                    </>
                  :
                  <>
                  

                     <>
                  

                  <table className="table  deal-info-table ">
                     
                     <tbody>
                         <tr>
                           <th scope="row">Deal Id: <span>{generatedDealId}</span></th>
                          
                           <th scope="row">Deal Type: <span>Investor</span></th>
                          
                            
                           
                         </tr>
                         <tr>
                           <th scope="row" colSpan={2}>Address : <span>{transaction?.contactAddress}</span></th>
                          
                         </tr>
                         <tr>
                           <th scope="row" colSpan={2} style={{color:'#9d3881'}}>Client Info (Principal applicant)</th>
                          
                         </tr>
                         <tr>
                           <th scope="row">Name:<span>{transaction?.clientName}</span></th>
                          
                           <th scope="row">Email: <span>{ transaction?.clientEmail}</span></th>
                          
                         </tr>
                         <tr>
                           <th scope="row">Primary Phone: <span>{transaction?.clientMobile}</span></th>
                          
                           <th scope="row">Secondary Phone: <span>{ transaction?.clientPhone}</span></th>
                          
                         </tr>
                         <tr>
                           <th scope="row" colSpan={2} style={{color:'#9d3881'}}>Client Info (Secondary)</th>
                         </tr>
                         <tr>
                           <th scope="row">Name: <span>{transaction?.secondaryClientName}</span></th>
                          
                           <th scope="row">Email: <span>{ transaction?.secondaryClientEmail}</span></th>
                          
                         </tr>
                         <tr>
                           <th scope="row">Primary Phone: <span>{transaction?.secondaryClientMobile}</span></th>
                          
                           <th scope="row">Secondary Phone: <span>{ transaction?.secondaryClientPhone}</span></th>
                          
                         </tr>
                    
                     <tr>
                           <th scope="row" colSpan={2} style={{color:'#9d3881'}}>Project Detail</th>
                         </tr>
                      <tr>
                        <th scope="row">Project Name: <span>{ investorListing?.project?.projectName }</span></th>
                       
                     
                        <th scope="row">Unit: <span>{ investorListing?.projects[0]?.selectedOptionText }</span></th>
                       
                      </tr>
                      <tr>
                        <th scope="row">Builder: <span>{ investorListing?.builder?.builderName }</span></th>
                       
                     
                        <th scope="row">Cost: <span>${investorListing?.projects[0]?.unitCost}</span></th>
                       
                      </tr>

                      <tr>
                        <th scope="row">Inside Sq.ft: <span>{investorListing?.projects[0]?.insideSqFt}</span></th>
                       
                     
                        <th scope="row">Outside Sq.ft: <span>{investorListing?.projects[0]?.outsideSqFt}</span></th>
                       
                      </tr>
                     <tr>
                      <th scope="row" colSpan="2">Notes: <span>{investorListing?.notes}</span></th>
                     </tr>
                      </tbody>
                    </table>
                  </>
                  </>
                  }

                  </TabPane>
                </TabContent>
              </OffcanvasBody>
            </Offcanvas>
        </div>
      </React.Fragment>
    )
  }



}


TransactionDashboard.propTypes = {
  t:  PropTypes.any,
  match: PropTypes.object,
  onGetAgentTransaction:PropTypes.func,
  onGetAgentAllTransaction:PropTypes.func,
  transactions:PropTypes.array,
  loading:PropTypes.object,
  alltransactions:PropTypes.array,
  onDeleteDeal:PropTypes.func
 

}
const mapStateToProps = ({ Transaction }) => (
  {
  
   transactions : Transaction.transactions,
   alltransactions:Transaction.alltransactions,
   loading: Transaction.loading

  })
const mapDispatchToProps = dispatch => ({
  onGetAgentTransaction: (agentId) => dispatch(getAgentTransaction(agentId)),
  onGetAgentAllTransaction: (agentId) => dispatch(getAgentAllTransaction(agentId)),
});

export default connect(mapStateToProps,mapDispatchToProps)(withTranslation()(TransactionDashboard))